import { ReactNode, useMemo } from 'react';
import { AccountAndBillingContext, AccountAndBillingContextValue } from './AccountAndBillingContext';

type AccountAndBillingProviderProps = AccountAndBillingContextValue & {
  children: ReactNode;
};

// Feature-local, not app-level: the Account & Billing root mounts this with the props the host passed it,
// so the feature's internal components read useAccountAndBilling() instead of being handed
// viewer/account/permissions one level at a time. Deliberately not exported from the package barrel —
// standalone leaves (table, search form, drawer) are mounted outside this root and take props instead.
export default function AccountAndBillingProvider({
  viewer,
  account,
  userPermissions,
  billingApi,
  secondTab,
  children,
}: AccountAndBillingProviderProps) {
  const value = useMemo(
    () => ({ viewer, account, userPermissions, billingApi, secondTab }),
    [viewer, account, userPermissions, billingApi, secondTab],
  );

  return <AccountAndBillingContext.Provider value={value}>{children}</AccountAndBillingContext.Provider>;
}
